import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19b7fa5c"
import script from "./bank.js?vue&type=script&lang=js&external"
export * from "./bank.js?vue&type=script&lang=js&external"
import style0 from "./bank.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports